import { useEffect } from 'react'
import { useWatch } from 'react-hook-form'
import { useMultiStepFormStore } from '../store/multiStepFormStore'

const useFormZustandPersist = (
    draftId,
    {
        storage,
        control,
        setValue,
        reset,
        exclude = [],
        onDataRestored,
        validate = false,
        dirty = false,
        touch = false,
        onTimeout,
        timeout
    }
) => {


    const watchedValues = useWatch({ control })
    const { getDraftByDraftId, upsertDraft, removeDraftByDraftId } = useMultiStepFormStore();


    useEffect(() => {

        if (draftId) {
            const draft = getDraftByDraftId(draftId)

            if (draft) {

                Object.keys(draft).forEach((key) => {
                    const shouldSet = !exclude.includes(key)
                    if (shouldSet) {
                        let value = draft[key]

                        if (key == 'asOfDate' && value) {
                            value = new Date(draft[key])
                        }

                        if (key == 'planYearDateOverride') {
                            let planYearDateOverride
                            if (value && value['planYearStartDateOverride'] && value['planYearEndDateOverride']) {
                                planYearDateOverride = {
                                    planYearStartDateOverride: new Date(value['planYearStartDateOverride']),
                                    planYearEndDateOverride: new Date(value['planYearEndDateOverride'])
                                }

                            }



                            value = planYearDateOverride

                        }

                        setValue(key, value, {
                            shouldValidate: validate,
                            shouldDirty: dirty,
                            shouldTouch: touch
                        })
                    }
                })
            } else {
                reset()
            }
        }

    }, [
        draftId,
        setValue
    ])

    useEffect(() => {
        // console.log({ watchedValues })
        if (watchedValues?.draftId) {
            const values = exclude.length
                ? Object.entries(watchedValues)
                    .filter(([key]) => !exclude.includes(key))
                    .reduce((obj, [key, val]) => Object.assign(obj, { [key]: val }), {})
                : Object.assign({}, watchedValues)

            if (Object.entries(values).length) {
                //  console.log('upsert', values)
                upsertDraft(values)
            }
        }

    }, [watchedValues])
    return {}
    // return removeDraftByDraftId(draftId)
}

export default useFormZustandPersist